import { useTranslation } from 'react-i18next';

import {
  GeneralModal,
  GeneralModalNoButtonVariant,
  SvgIcon,
} from '../../../Molecules';
import { SVGIconType } from '../../../../constants/svgIcon';
import { getSmartParentsImage } from '../../../../constants/images';
import styles from './MemoryBoostInfoModal.module.css';

type MemoryBoostInfoModalProps = {
  onClose: () => void;
};

export const MemoryBoostInfoModal = (props: MemoryBoostInfoModalProps) => {
  const { onClose } = props;
  const { t, i18n } = useTranslation();

  return (
    <GeneralModal
      onClose={onClose}
      buttonSetting={{
        noText: t('OK'),
        noVariant: GeneralModalNoButtonVariant.Cyan,
      }}
    >
      <div className={styles.memoryBoost}>
        <div className={styles.centerContainer}>
          <SvgIcon
            name={SVGIconType.MemoryWithAI}
            className={styles.memoryIcon}
            stroke={'#000000'}
          />
          <p className={styles.title}>{t('JOYAJOY AI Memory Boost')}</p>

          <p className={styles.subTitle}>
            {t(
              'Memory retention often decreases over time, and only around 10% of knowledge is retained on the seventh day after learning, according to a publication by Dr Hermann Ebbinghaus in 1885.',
            )}
          </p>
          <p className={styles.subTitle}>
            {t(
              'With JOYAJOY AI Memory Boost, it will deliver AI-scheduled revisions of memory games you played, which could enhance your memory retention by up to 9 times, jumping from ~10% to ~90%!',
            )}
          </p>

          <img
            src={getSmartParentsImage('img8', i18n.language)}
            className={styles.forgettingCurve}
          />
          <p className={styles.caption}>
            {t(
              'Use Cases: Examination, dictation, recitation, training, speech, lyrics, poems, etc.',
            )}
          </p>
          <p className={styles.caption}>
            {t('JOYAJOY AI Memory Boost is a patent-pending system.')}
          </p>
        </div>
      </div>
    </GeneralModal>
  );
};
